import { flowRight } from 'lodash/fp';
import { withProps } from 'recompose';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import baseDataForm from 'components/dataForm';
import { countErrors } from 'common/formValidation/lib';
import formValidate from './formValidate';

const dataForm = ({ form, ...options }) => flowRight([
    // override the validate props
    connect(null, { change }),
    withProps(({ change: updateField }) => ({
        // inform the form name
        form,
        // override the validate method
        validate: (values, props) => {
            // validate the form
            const errors = formValidate(values, props);

            // count the errors and persist them on the form
            updateField(form, 'errorCount', countErrors(errors));

            return errors;
        },
    })),
    // initialize the original data form
    baseDataForm(options),
]);

export default dataForm;
